import { useAuth } from 'routes/Menu/domains/auth'
import { CollectionId } from 'routes/Menu/domains/collections'
import { useIsTutorialPending } from 'routes/Menu/hooks/useIsTutorialPending'

export const CALORIES_TUTORIAL_NAME = 'customised_recipe_tiles_calories'

const SUPPORTED_COLLECTION_IDS = new Set<string>([
  CollectionId.AllRecipes,
  CollectionId.Recommendations,
])

export const useShouldShowCaloriesTutorial = (collectionId?: string) => {
  const { isAuthenticated } = useAuth()
  const isTutorialPending = useIsTutorialPending(CALORIES_TUTORIAL_NAME)

  return Boolean(
    isAuthenticated &&
      collectionId &&
      SUPPORTED_COLLECTION_IDS.has(collectionId) &&
      isTutorialPending,
  )
}
